// The one list of insurance cancellation reasons + labels, shared by
// every UI that can end a policy: CancelInsurancePolicyButton (the
// record's own page) and CleanupIvansCreatePolicyOverlay's "already
// ended" path (adding a policy the carrier's feed is still calling
// in-force, but that the steward knows has already ended).
//
// The values must stay in lockstep with VALID_CANCELLATION_REASONS in
// shared/db/insurance-policy-cancel.ts — that Set is what the server
// actually accepts, so a label added here with no matching server value
// would look pickable and then fail on submit.

export const CANCELLATION_REASON_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "lost_to_competitor", label: "Lost to competitor" },
  { value: "switched_carrier", label: "Switched carrier (still with us)" },
  { value: "client_request", label: "Client requested cancellation" },
  { value: "non_payment", label: "Non-payment" },
  { value: "non_renewal", label: "Non-renewal" },
  { value: "sold_property", label: "Sold property" },
  { value: "moved_out_of_state", label: "Moved out of state" },
  { value: "deceased", label: "Deceased" },
  { value: "other", label: "Other" },
];
